module.exports = __webpack_public_path__ + "static/media/doutora@2x.c3685aba.png";